import React, { useMemo } from "react";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTable from "../../../components/CustomTable/CustomTable";
import Text from "../../../components/Common/Text";
import CheckRender from "../../../components/Common/CheckRender";
import useEmpresa from "../../../hooks/useEmpresa";

const MODAL_COMENTARIOS_MAX_WIDTH = "600px";

const columnasComentarios = [
  {
    title: "Campo",
    dataIndex: "campo",
    key: "campo",
    width: "30%",
    render: (text) => (
      <div
        style={{
          fontWeight: "bold",
          color: "#333",
        }}
      >
        {text || "N/A"}
      </div>
    ),
  },
  {
    title: "Valor",
    dataIndex: "valor",
    key: "valor",
    width: "70%",
    render: (text) => (
      <div
        style={{
          wordBreak: "break-word",
          whiteSpace: "pre-wrap",
        }}
      >
        {text || "N/A"}
      </div>
    ),
  },
];

const ModalComentarios = ({ isOpen, onClose, comentariosAMostrar }) => {
  const empresa = useEmpresa();

  const dataComentarios = useMemo(() => {
    if (!comentariosAMostrar) {
      return [];
    }

    const comentarioValidacion =
      comentariosAMostrar?.estatusCobertura?.comentarioValidacion || "";
    const observacionSpool =
      comentariosAMostrar?.estatusCobertura?.observacionSpool || "";
    const comentarioSpool =
      comentariosAMostrar?.cobertura?.comentario || "Sin comentarios";

    const datos = [];

    if (comentarioValidacion) {
      datos.push({
        key: "comentario-validacion",
        campo: "Comentario de validación",
        valor: comentarioValidacion,
      });
    }

    if (observacionSpool) {
      datos.push({
        key: "observacion-spool",
        campo: "Observación Spool",
        valor: observacionSpool,
      });
    }

    datos.push({
      key: "comentario-spool",
      campo: "Comentario spool",
      valor: comentarioSpool,
    });

    return datos;
  }, [comentariosAMostrar]);

  const tieneComentarios = dataComentarios.length > 0;

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      testid="modal-comentarios"
      maxWidth={MODAL_COMENTARIOS_MAX_WIDTH}
    >
      <Section flexDirection="column">
        <Text
          size="20px"
          weight="bold"
          color={empresa?.COLOR_PRINCIPAL}
          margin="0 0 20px 0"
        >
          Comentarios
        </Text>
        <CheckRender allowed={tieneComentarios}>
          <CustomTable
            columns={columnasComentarios}
            dataSource={dataComentarios}
            pageSize={10}
            containerWidth="100%"
            width="100%"
            testid="comentarios-table"
          />
        </CheckRender>
        <CheckRender allowed={!tieneComentarios}>
          <div
            style={{
              textAlign: "center",
              padding: "40px",
              color: "#666",
              fontSize: "16px",
            }}
          >
            No hay comentarios disponibles para esta cobertura
          </div>
        </CheckRender>
      </Section>
    </CustomModal>
  );
};

export default ModalComentarios;

